// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1EJfk","select":"Header_select__38cUA","clinic":"Header_clinic__xKoBG"};